import { render, staticRenderFns } from "./AddReservationForm.vue?vue&type=template&id=24468730&"
import script from "./AddReservationForm.vue?vue&type=script&lang=js&"
export * from "./AddReservationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports